/* eslint-disable flowtype/require-valid-file-annotation */
module.exports = require('../lib/native')



//////////////////
// WEBPACK FOOTER
// ./~/styled-components/native/index.js
// module id = 49
// module chunks = 0